import { useState } from "react";
import { Controller, useController } from "react-hook-form";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import Button from "../../../Buttons/Button";
import ModalTikTokInstantForms from "./ModalTikTokInstantForms";
import { useTranslationApp } from "../../../../lib/i18next";
import { getReactHookFormNestedError } from "../../../../utils/errors";
import InstantFormSummaryButton from "../../../Buttons/InstantFormSummaryButton";
import AdMediaPreviewTooltipContent, {
  adMediaHoverPreviewHeight,
} from "../../../Common/AdMediaPreviewTooltipContent";
import {
  BUTTON_SELECT_INSTANT_FORM,
  FIELD_REQUIRED,
  MODAL_VIEW_LEAD_FORM_TITLE,
} from "../../../../i18n/keysTranslations";

const InstantFormTikTokContainer = ({
  name,
  integrationID,
  adAccountID,
  language,
  control,
  errors = {},
  disabled,
  onSelected = () => {},
}) => {
  const {
    field: { value, onChange },
  } = useController({
    control,
    name,
    defaultValue: null,
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const error = getReactHookFormNestedError(errors, name);
  const { t } = useTranslationApp();
  const isEmptyTemplate = _.isEmpty(value);
  const previewUrl = value?.previewUrl || "";
  const thumbnail = value?.thumbnail || "";

  const onSelect = (instantForm) => {
    onChange(instantForm);
    onSelected(instantForm);
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: {
          value: true,
          message: t(FIELD_REQUIRED),
        },
      }}
      render={() => (
        <Box id={name}>
          {!isEmptyTemplate && (
            <InstantFormSummaryButton
              name={value.name || value.id}
              onClick={
                previewUrl || thumbnail ? () => setPreviewOpen(true) : undefined
              }
            />
          )}
          {!disabled && (
            <Button
              type="button"
              color="secondary"
              onClick={() => setModalOpen(true)}
              disabled={disabled || !integrationID || !adAccountID}
              sx={{ mt: 1.5, width: "100%" }}
            >
              {t(BUTTON_SELECT_INSTANT_FORM)}
            </Button>
          )}
          {error?.message && (
            <Typography variant="body2" color="error">
              {error.message}
            </Typography>
          )}
          <Dialog
            open={previewOpen}
            onClose={() => setPreviewOpen(false)}
            aria-label={t(MODAL_VIEW_LEAD_FORM_TITLE)}
            PaperProps={{
              sx: {
                backgroundColor: "#FFFFFF",
                borderRadius: 3,
                border: "1px solid #E5E5E5",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
                overflow: "hidden",
                m: 2,
                width: previewUrl ? 390 : "auto",
                maxWidth: "92vw",
              },
            }}
          >
            {previewUrl ? (
              <Box
                component="iframe"
                src={previewUrl}
                title={t(MODAL_VIEW_LEAD_FORM_TITLE)}
                sx={{
                  display: "block",
                  width: "100%",
                  height: "min(720px, 80vh)",
                  border: 0,
                }}
              />
            ) : thumbnail ? (
              <AdMediaPreviewTooltipContent
                mediaUrls={[thumbnail]}
                height={adMediaHoverPreviewHeight}
              />
            ) : null}
          </Dialog>
          {modalOpen && (
            <ModalTikTokInstantForms
              modalOpen={modalOpen}
              integrationID={integrationID}
              adAccountID={adAccountID}
              language={language}
              onCloseModal={() => setModalOpen(false)}
              onCallbackSelect={onSelect}
            />
          )}
        </Box>
      )}
    />
  );
};

export default InstantFormTikTokContainer;
